import { AccountType, Plan } from "./../store/models/accounts";
import { catchError, map } from "rxjs/operators";
import { http, messageError } from "./base";

export type AccountPayload = {
  nickname: string;
  type: AccountType;
  age: string;
  birthdate: string;
  plan: Plan;
  card?: string;
};

export type AccountResponse = {
  id: string;
  plan: Plan;
  type: AccountType;
  nickname: string;
  age: number;
  birthdate: string;
  balance: number;
  yearlyBreakdown: { age: number; year: number; amount: number }[];
};

export function createAccount(payload: AccountPayload) {
  return http.post("/accounts/", payload).pipe(
    map(({ data }: { data: AccountResponse }) => {
      return data;
    }),
    catchError((error) => {
      return messageError(error, "Failed to create account.");
    })
  );
}

export function fetchAccounts() {
  return http.get("/accounts/").pipe(
    map(({ data }: { data: AccountResponse[] }) => {
      return data;
    }),
    catchError((error) => {
      return messageError(error, "Failed to fetch accounts.");
    })
  );
}
